import { EventBus } from './../../main';
import { API } from '../../services/api'

const state = () => ({
  users: [],
})

const getters = {
  userList: (state) => {
    return state.users
  },
}

const actions = {
  async getUsers ({ commit }) {
    try{
      const res = await API.get('/api/user/all')
      commit('ChangeUserList', res.data)
    } catch(err) {
      EventBus.$emit('systemNotification', 'Something went wrong 🤔')
      console.log(err);
    }
  },
  // async inviteUser ({ commit }, data) {
  //   try{
  //     const res = await authService.register(data.name, data.email, data.password, data.type);
  //     console.log(res)
  //     commit('ChangeUser', res.data.user)
  //     commit('AuthUser', {bool:true, token:res.data.token})
  //     window.location.href = "/"
  //   } catch(err) {
  //     console.log(err);
  //     EventBus.$emit('systemNotification', 'Something went wrong 🤔')
  //   }
  // },
  async deleteUser ({ commit }, userInputs) {
    try{
      const res = await API.get('/api/user/delete/'+userInputs)
      commit('ChangeUserList', res.data)
      EventBus.$emit('systemNotification', 'Deleted user successfully!')
    } catch(err) {
      console.log(err);
      EventBus.$emit('systemNotification', 'Something went wrong 🤔')
    }
  },
  // async updateUser ({ commit }, userInputs) {
  //   try{
  //     const res = await authService.update(userInputs.name, userInputs.email);
  //     commit('ChangeUser', res.data.user)
  //     EventBus.$emit('systemNotification', 'Updated user')
  //   } catch(err) {
  //     console.log(err)
  //     EventBus.$emit('systemNotification', 'Something went wrong 🤔')
  //   }
  // },
}

const mutations = {
  ChangeUserList (state, data) {
    state.users = data;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}